import { render, staticRenderFns } from "./ChecklistYTV.vue?vue&type=template&id=5360d4ae&scoped=true&"
import script from "./ChecklistYTV.vue?vue&type=script&lang=ts&"
export * from "./ChecklistYTV.vue?vue&type=script&lang=ts&"
import style0 from "./ChecklistYTV.vue?vue&type=style&index=0&id=5360d4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5360d4ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VSimpleTable,VTextField})
